import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { OnboardingRecord } from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const onboardingApi = {
	get: (workspaceId: string): Promise<AxiosResult<OnboardingRecord[]>> => {
		return axiosRequest({ url: `${API_BASE_URL}/${workspaceId}/onboarding`, method: "GET" });
	},

	complete: (workspaceId: string, step: string): Promise<AxiosResult<OnboardingRecord>> => {
		return axiosRequest({ url: `${API_BASE_URL}/${workspaceId}/onboarding/${step}/complete`, method: "POST" });
	},
};
